//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      showPlay: true
    }
  },
  computed: {
    // 是否为移动端
    isM () {
      return this.$store?.state?.isMobile
    },
    // 是否为pad端
    isPad () {
      return this.$store.state.screenWidth >= 800 && this.$store.state.screenWidth < 1000
    }
  },
  methods: {
    play () {
      this.showPlay = false
      this.$refs.video.play()
    }
  }
}
